import React from 'react';
import './Location.css';
import {
  LocationOn,
  AccessTime,
  Coffee,
  LocalCafe,
  Directions,
  Event,
  People,
  CalendarToday
} from '@mui/icons-material';

const Location = () => {
  const openMaps = () => {
    const address = "Craft.19 Coffee Shop, Main Street, Sumner";
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`, '_blank');
  };

  const sendEmail = () => {
    window.location.href = 'mailto:KFoster98@proton.me';
  };

  return (
    <section className="location-section">
      <div className="location-container">
        {/* Header */}
        <div className="location-header">
          <h2 className="location-title">Our Weekly Gathering</h2>
          <p className="location-subtitle">
            Join us every Wednesday for networking in a friendly, welcoming environment
          </p>
        </div>

        <div className="location-content">
          {/* Left Side - Content */}
          <div className="location-info">
            {/* Main Description */}
            <div className="location-description">
              <h3>Perfect Setting for Meaningful Connections</h3>
              <p>
                Our weekly meetings take place at Craft.19 Coffee Shop, a cozy and inviting 
                establishment that provides the ideal atmosphere for building professional 
                relationships. The casual environment helps break down barriers and encourages 
                authentic conversations.
              </p>
            </div>

            {/* Two Box Row */}
            <div className="info-boxes-row">
              {/* Box 1 - Venue Details */}
              <div className="info-box venue-box">
                <div className="box-header">
                  <div className="box-icon">
                    <LocalCafe className="icon" />
                  </div>
                  <h4>Venue Details</h4>
                </div>
                <div className="box-content">
                  <div className="detail-item">
                    <LocationOn className="detail-icon" />
                    <div className="detail-text">
                      <span className="detail-label">Address</span>
                      <span className="detail-value">Craft.19 Coffee Shop, Main Street, Sumner</span>
                    </div>
                  </div>
                  <div className="detail-item">
                    <Coffee className="detail-icon" />
                    <div className="detail-text">
                      <span className="detail-label">Venue Type</span>
                      <span className="detail-value">Cozy Coffee Shop</span>
                    </div>
                  </div>
                  <div className="detail-item">
                    <People className="detail-icon" />
                    <div className="detail-text">
                      <span className="detail-label">Capacity</span>
                      <span className="detail-value">Small, Intimate Groups</span>
                    </div>
                  </div>
                </div>
                <button 
                  className="box-button"
                  onClick={openMaps}
                >
                  <Directions className="button-icon" />
                  Get Directions
                </button>
              </div>

              {/* Box 2 - Event Schedule */}
              <div className="info-box schedule-box">
                <div className="box-header">
                  <div className="box-icon">
                    <Event className="icon" />
                  </div>
                  <h4>Event Schedule</h4>
                </div>
                <div className="box-content">
                  <div className="detail-item">
                    <AccessTime className="detail-icon" />
                    <div className="detail-text">
                      <span className="detail-label">Time</span>
                      <span className="detail-value">Every Wednesday at 8:00 AM</span>
                    </div>
                  </div>
                  <div className="detail-item">
                    <CalendarToday className="detail-icon" />
                    <div className="detail-text">
                      <span className="detail-label">Frequency</span>
                      <span className="detail-value">Weekly</span>
                    </div>
                  </div>
                  <div className="detail-item">
                    <People className="detail-icon" />
                    <div className="detail-text">
                      <span className="detail-label">Duration</span>
                      <span className="detail-value">1-1.5 Hours</span>
                    </div>
                  </div>
                </div>
                <button 
                  className="box-button"
                  onClick={sendEmail}
                >
                  <Event className="button-icon" />
                  Email your response
                </button>
              </div>
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="location-image">
            <div className="image-container">
              <div 
                className="location-main-image"
                style={{
                  backgroundImage: `url('./coffee.jpg')`
                }}
              />
              <div className="image-overlay" />
              
              {/* Image Content */}
              <div className="image-content">
             
                
                <div className="image-features">
           
               
             
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;